<template>
  <div class="h-dialogContainer" v-if="hasReset">
    <div class="h-borderBox">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">{{$t('SubscriberIms.impuinfoDiv')}}</div>
      <div class="h-subscriber-div-padding">
        <template>
        <BaseBusiness formId='impuinfo' :formParams='formParamsUserImpuInfo' :reMountPage='reMount' :opCode='opCode' ref="impuinfo" :funcOnChange ='bindOnChangeInterface' formPattern="2"></BaseBusiness>
        </template>
      </div>
      <div id="template" class='row h-row-inputBox h-subscriber-div-padding' v-if="showTemplate">
        <div class='col-sm-6 h-col-inputBox-t'>
          <div class='h-inputLit'>{{$t('SubscriberIms.template')}}</div>
          <ejs-dropdownlist :dataSource='templateInfo' :change= "templateChange"/>
        </div>
      </div>
    </div>
    <div class="h-borderBox" v-show="showSubInfo">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">
        <span>{{$t('SubscriberIms.subInfoDiv')}}</span>
      </div>
      <div class="h-subscriber-div-padding">
        <template>
        <BaseBusiness formId='subInfo' :formParams='formParamsSubImpuInfo' :reMountPage='reMount' :opCode='opCode' ref="subInfo" formPattern="2"></BaseBusiness>
        </template>
      </div>
    </div>
    <div class="h-borderBox">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">
        <!--{{$t('SubscriberIms.serviceProfileInfoDiv')}}-->
        <ejs-checkbox v-if="showCheckbox" :label="$t('SubscriberIms.serviceProfileInfoDiv')" @change="changeFun"></ejs-checkbox><span v-if="!showCheckbox">{{$t('SubscriberIms.serviceProfileInfoDiv')}}</span>
      </div>
      <div class="h-subscriber-div-padding">
        <template>
        <BaseBusiness formId='serviceProfileInfo' :formParams='formParamsUserServiceProfileInfo' :reMountPage='reMount' :opCode='opCode' ref="serviceProfileInfo" formPattern="2"></BaseBusiness>
        </template>
      </div>
    </div>
    <div class="h-borderBox" v-show="showSupplementaryInfo">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">
        <!--{{$t('SubscriberIms.supplementaryInfoDiv')}}-->
        <ejs-checkbox v-if="showCheckbox" :label="$t('SubscriberIms.supplementaryInfoDiv')" @change="changeSupplementFun"></ejs-checkbox><span v-if="!showCheckbox">{{$t('SubscriberIms.supplementaryInfoDiv')}}</span>
      </div>
      <div class="h-subscriber-div-padding">
        <template>
          <BaseBusiness formId='supplementaryInfo' :formParams='formParamsUserAdditionInfo' :reMountPage='reMount' :opCode='opCode' ref="supplementaryInfo" :funcKeyUp='bindOnChangeSupplementaryInfo' formPattern="2"></BaseBusiness>
        </template>
      </div>
    </div>
    <CustomDialog ref='qryVpnInfoPage' :element='dialog.element.eleQryVpnInfo' :styles='dialog.vpnstyles'>
      <template v-slot:dialog-content>
        <OrganizationalTree ref="organizationalTreeInner" :neid="neid" :vpndata="vpndata" :disableNodes="disableNode" :existFlag="false">></OrganizationalTree>
      </template>
    </CustomDialog>
    <CustomDialog ref='StaffInfoPage' :element='dialog.element.eleStaffInfo' :styles='dialog.staffstyles' >
      <template v-slot:dialog-content>
        <StaffInfo ref='staff' :neid="neid"></StaffInfo>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import BaseBusiness from '../U_BaseBusiness';
  import CustomDialog from '../../../../common/CustomDialog';
  import OrganizationalTree from '../../../util/OrganizationalTree';
  import StaffInfo from './StaffInfo';
  import SubscriberArrTool from "../../../util/parseFormNew/tools/subscriberTool";
  import {EventBus} from '../../../../../plugins/eventBus';
  import batchModCommon from '../../group/batchModCommon';

  export default {
    name: 'AddImsGroupDialog',
    components: {
      BaseBusiness,
      CustomDialog,
      OrganizationalTree,
      StaffInfo,
    },
    mixins: [batchModCommon],
    props: [
      'neid',
      'msgid',
      'opCode',
      'node'
    ],
    methods: {
      showLoadding(timeout) {
        this.$loading.showLoadding(this.$t('SubscriberIms.loading'));
        setTimeout(() => {
          this.$loading.hideLoadding();
        }, timeout);
      },
      addZero(str) {
        console.log("before",str);
        if(str){
          const arr = [ "", "0000", "000", "00", "0" ];
          if (str.length == 5) {
            return str;
          }
          console.log("after",(arr[str.length] + str));
          arr[str.length] + str;
          return arr[str.length] + str;
        }
        return "";
      },
      getImpuByDialplan(item, type) { // type=1，添加；type=2,批量添加
        if (type !== 'add' && type !== 'batchAdd') {
          return item;
        }
        if (item['impu[zone]'] === '' || item['impu[zone]'] === undefined) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkZoneTip')});
          return false;
        }
        // 起始号码范围判断
        if (type === 'batchAdd') {
          if (parseInt(item['impu[startNo]'], 0) > parseInt(item['impu[endNo]'], 0)) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.endNOLessStartNo')});
            return false;
          }
        }
        let impuMin = 0;
        let impuMax = 0;
        if(this.dialPlan === this.dialPlanList[1]){
          if(item['impu[zone]'] < 328 || item['impu[zone]']> 806){
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.zoneTip')});
            return false;
          }
          if(item['rtttype'] === 2 || item['rtttype'] === 8){
            if (type === 'add') {
              impuMin = `${item['impu[zone]']}${item['impu[number]']}`;
            } else if (type === 'batchAdd') {
              impuMin = `${item['impu[zone]']}${item['impu[startNo]']}`;
              impuMax = `${item['impu[zone]']}${item['impu[endNo]']}`;
            }
          }
          else if (item['rtttype'] === 1 || item['rtttype'] === 3 || item['rtttype'] === 4 || item['rtttype'] === 5 || item['rtttype'] === 6){
            if (type === 'add') {
              impuMin = `${item['impu[zone]']}${item['impu[fleet]']}${item['impu[number]']}`;
            } else if (type === 'batchAdd') {
              impuMin = `${item['impu[zone]']}${item['impu[fleet]']}${item['impu[startNo]']}`;
              impuMax = `${item['impu[zone]']}${item['impu[fleet]']}${item['impu[endNo]']}`;
            }
          }
        }else if( this.dialPlan === this.dialPlanList[0]){
          if(item['impu[zone]'].length !==2 ){
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.DMRZoneTip')});
            return false;
          }
          if (type === 'add') {
            const number = this.addZero(item['impu[number]']);
            impuMin = `${item['impu[zone]']}${number}`;
          } else if (type === 'batchAdd') {
            const startNo = this.addZero(item['impu[startNo]']);
            const endNo = this.addZero(item['impu[endNo]']);
            impuMin = `${item['impu[zone]']}${startNo}`;
            impuMax = `${item['impu[zone]']}${endNo}`;
          }
        }
        else if(this.dialPlan === this.dialPlanList[2] ){
          if(item['impu[zone]'] < 328 || item['impu[zone]']> 806){
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.zoneTip')});
            return false;
          }
          if (type === 'add') {
            if(item['rtttype'] === 1 || item['rtttype'] === 3 || item['rtttype'] === 4 || item['rtttype'] === 6){
              if(item['impu[number]'] >= 30000 && item['impu[number]'] <= 30019){
                EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.numTip')});
                return false;
              }
            }
            const number = this.addZero(item['impu[number]']);
            impuMin = `${item['impu[zone]']}${number}`;
          } else if (type === 'batchAdd') {
            if(item['rtttype'] === 1 || item['rtttype'] === 3 || item['rtttype'] === 4 || item['rtttype'] === 6){
              if(item['impu[startNo]'] >= 30000 && item['impu[startNo]'] <= 30019){
                EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.numTip')});
                return false;
              }
              if(item['impu[endNo]'] >= 30000 && item['impu[endNo]'] <= 30019){
                EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.numTip')});
                return false;
              }
            }
            const startNo = this.addZero(item['impu[startNo]']);
            const endNo = this.addZero(item['impu[endNo]']);
            impuMin = `${item['impu[zone]']}${startNo}`;
            impuMax = `${item['impu[zone]']}${endNo}`;
          }
        }
        if (!(impuMax === 0 || impuMin === 0)) {
          item.opCount = item['impu[endNo]'] - item['impu[startNo]'] + 1;
          console.log('opcount',item.opCount);
        } else {
          item.opCount = 1;
        }
        item.impu = impuMin;
        return item;
      },
      $bindRtttype(key) {
        this.funcMap.set(key, () => {
          const rtttype = this.$refs.impuinfo.$refs.bus.$refs.rtttype[0].data.value;
          setTimeout(() => {
            this.setInvalidtime();
            this.bindClickAfterPageCreated();
            if (rtttype === 2 || rtttype === 4 || rtttype === 6) {
              const voiceDefaultValue = this.neversion.indexOf("_V22") > 0 ? 0 : 128;
              const mediaDefaultValue = this.neversion.indexOf("_V22") > 0 ? 0 : 21484;
              this.$refs.serviceProfileInfo.$refs.bus.setData('voiceClass', voiceDefaultValue);
              this.$refs.serviceProfileInfo.$refs.bus.setData('mediaClass', mediaDefaultValue);
              this.$refs.serviceProfileInfo.$refs.bus.setData('dataClass', 0);
              this.$refs.serviceProfileInfo.$refs.bus.setData('otherClass', 0);
            }
            else if (rtttype === 1 || rtttype === 3 || rtttype === 5 || rtttype === 8) {
              this.$refs.serviceProfileInfo.$refs.bus.setData('voiceClass', 0);
              this.$refs.serviceProfileInfo.$refs.bus.setData('mediaClass', 0);
              this.$refs.serviceProfileInfo.$refs.bus.setData('dataClass', 0);
              this.$refs.serviceProfileInfo.$refs.bus.setData('otherClass', 0);
            }
            const _dialPlan = parseInt(this.dialPlan, 0);
            if(_dialPlan === 5)//P3
            {
              if(rtttype === 2 || rtttype === 8) {
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[fleet]','hidden',true);//队号隐藏
                const validate ={range:[[100, 109], this.$t('SubscriberIms.numDialTip5')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
                this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '100~109');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '100~109');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '100~109');
              }
              else if(rtttype === 1 || rtttype === 3 || rtttype === 4 || rtttype === 5 || rtttype === 6){
                const fleetOptions = [];
                for (let index = 20; index <= 89; index++) {
                  fleetOptions.push({ showName: index, value: index });
                }
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[fleet]','hidden',false);//队号显示
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[fleet]','options',fleetOptions);//队号赋值
                this.$refs.impuinfo.$refs.bus.setData('impu[fleet]',20);

                const validate ={range:[[200, 899], this.$t('SubscriberIms.numDialTip6')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
                this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '200~899');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '200~899');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '200~899');
              }
            }
            else if(_dialPlan === 6)//ZJ
            {
              if(rtttype === 2 || rtttype === 5 || rtttype === 8){
                const validate ={range:[[1, 32767], this.$t('SubscriberIms.numDialTip3')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
                this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '00001~32767');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '00001~32767');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '00001~32767');
              }
              else if(rtttype === 1 || rtttype === 3 || rtttype === 4 || rtttype === 6){
                const validate ={range:[[1,32767],this.$t('SubscriberIms.numDialTip4')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
                this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '00001~29999,30019~32767');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '00001~29999,30019~32767');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '00001~29999,30019~32767');
              }
            }
          }, 50);
        });
      },
      $bindZone(key) {
        this.funcMap.set(key, () => {
          const _dialPlan = parseInt(this.dialPlan, 0);
          if(_dialPlan === 4){//DMR
            const map = this.$refs.impuinfo.getDatas();
            const returnObj = {};
            Array.from(map).forEach(([key, value]) => {
              returnObj[key] = value;
            });
            if(this.checkDmrZone(returnObj['impu[zone]']))
            {
              const validate ={range:[[1,99999],this.$t('SubscriberIms.numDialTip7')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
              this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '00001~99999');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '00001~99999');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '00001~99999');
            }
            else{
              const validate ={range:[[0,99999],this.$t('SubscriberIms.numDialTip2')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
              this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '00000~99999');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '00000~99999');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '00000~99999');
            }
          }
        });
      },
      $bindFleet(key) {
        this.funcMap.set(key, () => {
          const _dialPlan = parseInt(this.dialPlan, 0);
          if(_dialPlan === 5){//P3
            const map = this.$refs.impuinfo.getDatas();
            const returnObj = {};
            Array.from(map).forEach(([key, value]) => {
              returnObj[key] = value;
            });
            if(returnObj['impu[fleet]'] >= 20 && returnObj['impu[fleet]'] <= 41)
            {
              const validate ={range:[[200,899],this.$t('SubscriberIms.numDialTip8')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
              this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '200~899');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '200~899');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '200~899');
            }
            else if(returnObj['impu[fleet]'] >= 42 && returnObj['impu[fleet]'] <= 89){
              const validate ={range:[[200,549],this.$t('SubscriberIms.numDialTip9')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
              this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '200~549');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '200~549');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '200~549');
            }
          }
        });
      },
      $bindInvalidtime(key) {
        this.funcMap.set(key, () => {
          this.setInvalidtime();
        });
      },
      setInvalidtime() {
        if(this.$refs.impuinfo.$refs.bus.$refs.invalidtime) {
          const today = new Date(new Date(new Date().toLocaleDateString()).getTime());
          this.$refs.impuinfo.$refs.bus.$refs.invalidtime[0].setMin(today);
        }
      },
      $bindPassword(origin, confirm) {
        const $this = this;
        $this.funcKeyUpMap.set(origin, () => {
          const supplementaryInfo = $this.$refs.supplementaryInfo.$refs.bus;
          const originValue = supplementaryInfo.getAttrByName(origin, 'value');
          const confirmValue = supplementaryInfo.getAttrByName(confirm, 'value');
          let newRule = {};
          if (originValue === confirmValue) {
            newRule = {
              required: [true, this.$t('SubscriberIms.require')],
              rangeLength: [[8, 63], this.$t('SubscriberIms.charAt63')],
              regex: [this.passwordRegex, this.$t('SubscriberIms.passwordRegex')],
            };
          } else {
            newRule = {
              required: [true, this.$t('SubscriberIms.require')],
              rangeLength: [[8, 63], this.$t('SubscriberIms.charAt63')],
              regex: [this.passwordRegex, this.$t('SubscriberIms.passwordRegex')],
              range:[[9,8], this.$t('SubscriberIms.passwordEqual')],
            };
          }
          supplementaryInfo.removeValidate(origin);
          supplementaryInfo.removeValidate(confirm);
          supplementaryInfo.setValidate(origin, newRule);
          supplementaryInfo.setValidate(confirm, newRule);
          supplementaryInfo.validateResult([origin, confirm]);
        });
        $this.funcKeyUpMap.set(confirm, () => {
          const supplementaryInfo = $this.$refs.supplementaryInfo.$refs.bus;
          const originValue = supplementaryInfo.getAttrByName(origin, 'value');
          const confirmValue = supplementaryInfo.getAttrByName(confirm, 'value');
          let newRule = {};
          if (originValue === confirmValue) {
            newRule = {
              required: [true, this.$t('SubscriberIms.require')],
              rangeLength: [[8, 63], this.$t('SubscriberIms.charAt63')],
              regex: [this.passwordRegex, this.$t('SubscriberIms.passwordRegex')],
            };
          } else {
            newRule = {
              required: [true, this.$t('SubscriberIms.require')],
              rangeLength: [[8, 63], this.$t('SubscriberIms.charAt63')],
              regex: [this.passwordRegex, this.$t('SubscriberIms.passwordRegex')],
              range:[[9,8], this.$t('SubscriberIms.passwordEqual')],
            };
          }
          supplementaryInfo.removeValidate(origin);
          supplementaryInfo.removeValidate(confirm);
          supplementaryInfo.setValidate(origin, newRule);
          supplementaryInfo.setValidate(confirm, newRule);
          supplementaryInfo.validateResult([origin, confirm]);
        });
      },
      checkDmrZone(zone)
      {
        if(zone === '00' ||
          zone === '10' ||
          zone === '20' ||
          zone === '30' ||
          zone === '40' ||
          zone === '50' ||
          zone === '60' ||
          zone === '70' ||
          zone === '80' ||
          zone === '90' ){
          return true;
        }
      },
      async mainHandler(_data = [], propinfo, response) {

        const $this     = this;
        $this.opCode    = propinfo.opCode;
        $this.neid      = propinfo.neid;
        $this.neversion = propinfo.neversion;
        $this.dialPlan  = propinfo.dialPlan;
        $this.vpnclass  = propinfo.vpnclass;

        const res = response.data.resultVal;

        if (propinfo.opCode === 'mod') {
          this.info.vpnid = _data[0].vpnid;
          const vpntree = this.$parent.$parent.$parent.$refs.modUser.$parent.$parent.$parent.$parent.$parent.$refs.organizationalTree;
          if (_data[0].vpnid === 0) {
            if (this.node.neNode.equipmentName === undefined) {
              _data[0].vpnid = this.$t('SubscriberIms.organization');
            } else {
              _data[0].vpnid = `${this.$t('SubscriberIms.organization')}[${this.node.neNode.equipmentName}]`;
            }
          } else {
            const vpnStr = `${propinfo.neid}_7_${_data[0].vpnid}`;
            _data[0].vpnid =  vpntree.getNodeName(vpnStr);
          }
          $this.vpndata = vpntree.initData;
          $this.disableNode = vpntree.disableNode;

          const { devAdapter } = this.$parent.$parent.$parent.$refs;
          const record = await devAdapter.getModUserRecords(propinfo, _data[0]);
          console.log('record:', record);

          $this.passwordbefore = record['password'];
          $this.realmbefore    = record['realm'];
          $this.lteimsibefore  = record['lteimsi'];

          const sub = new SubscriberArrTool();
          const resultMap = sub.$devideByGroupBy(res, record);
          $this.showTemplate = false;
          $this.initTemplateInfo();
          $this.callPageShow($this, resultMap, propinfo);
          _data[0].vpnid = this.info.vpnid;

        } else if (propinfo.opCode === 'batchMod') {
          const vpntree = this.$parent.$parent.$parent.$refs.modUser.$parent.$parent.$parent.$parent.$parent.$refs.organizationalTree;
          const vpnStr = `${propinfo.neid}_7_${_data[0].vpnid}`;
          console.log('vpnStr=', vpnStr);
          $this.vpndata = vpntree.initData;
          $this.disableNode = vpntree.disableNode;
          res.forEach((item)=> {
            if(item.name === "rtttype") {//终端类型
              item.value = _data[0].rtttype;
              item.options[0].attr.forEach((item_1) => {
                if(item_1.name === "voiceClass") {
                  item_1.value = "0";
                }
                if(item_1.name === "mediaClass") {
                  item_1.value = "0";
                }
              })
              return;
            }
          });
          const sub = new SubscriberArrTool();
          const resultMap = sub.$devideByGroupBy(res, _data);
          $this.showSupplementaryInfo = false;
          console.log("showSupplementaryInfo",$this.showSupplementaryInfo)
          $this.showTemplate = false;
          $this.showCheckbox = true;
          $this.initTemplateInfo();
          $this.callPageShow($this, resultMap, propinfo);
        } else {
          const sub = new SubscriberArrTool();
          const resultMap = sub.$devideByGroupBy(res,_data[0])
          $this.showTemplate = true;
          $this.initTemplateInfo();
          $this.handlerBasicInfo(propinfo, res, $this, resultMap);
        }
      },
      callPageShow($this, resultMap, propinfo) {
        const arrSub = resultMap.get($this.formParamsSubImpuInfo.modelName);
        $this.formParamsSubImpuInfo = arrSub;
        const arrBase = resultMap.get($this.formParamsUserImpuInfo.modelName);
        $this.formParamsUserImpuInfo = arrBase;
        const arrDevice = resultMap.get($this.formParamsUserServiceProfileInfo.modelName);
        $this.formParamsUserServiceProfileInfo = arrDevice;
        const arrServe = resultMap.get($this.formParamsUserAdditionInfo.modelName);
        $this.formParamsUserAdditionInfo = arrServe;
        setTimeout(() => {
          $this.setInvalidtime();
          $this.bindClickAfterPageCreated();
          this.arrBaseBak = JSON.stringify(arrBase);
          this.arrDeviceBak = JSON.stringify(arrDevice);
          this.arrServeBak = JSON.stringify(arrServe);
          if ($this.showCheckbox) {
            $this.initState(arrBase, arrDevice, arrServe);
          }
        }, 200);
      },
      initState(arrBase, arrDevice, arrServe) {
        console.log('nogroup=', arrBase);
        console.log('arrDevice=', arrDevice);
        // this.arrBaseBak = JSON.stringify(arrBase);
        // this.arrDeviceBak = JSON.stringify(arrDevice);
        // 初始化不分组字段showName前增加checkbox
        this.bindCheckbox('impuinfo', arrBase);
        if (this.showCheckbox) {
          this.setDisabled('impuinfo', arrBase);
          this.setDisabled('serviceProfileInfo', arrDevice);
          this.setDisabled('supplementaryInfo', arrServe);
        }
      },
      /**
       * 区号、队号获取；组织架构值设置
       * @param propinfo
       * @param res
       * @returns {*}
       */

      handlerBasicInfo(propinfo, res, $this, resultMap) {
        // 区号队号查询赋值
        this.paramForInner.vo['0'] = this.neid;
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', this.paramForInner).then((response) => {
          console.log('getZone=', response);
          if (response.status !== 200) {
            EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.requestResTip') });
          } else {
            if (response.data === '' || response.data.errorCode !== '0') {
              EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.checkZoneTip')});
            } else if (typeof (response.data) !== 'undefined' && response.data.resultVal.length > 0) {
              resultMap = $this.setParameterWithDialplan(propinfo, response, res, resultMap);
            } else {
              EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.checkZoneTip')});
            }
          }
          $this.callPageShow($this, resultMap, propinfo);
        });
      },

      setParameterWithDialplan(propinfo, response, res, resultMap) {
        // 根据拨号方案设置队号、个号的范围---包括单开、批开
        // 处理拨号方案:5 p3 4 dmr 6 zj-pocsss
        const _dialPlan    = parseInt(propinfo.dialPlan, 0);
        const zoneOptions  = [];
        const fleetOptions = [];
        let   rtttype      = 0;

        const zoneRes = JSON.parse(response.data.resultVal);
        //区号,与拨号方案无关
        zoneRes.forEach((item) => {
          zoneOptions.push({ showName: item, value: item });
        });

        if(_dialPlan === this.dialPlanList[1])//P3
        {
          res.forEach((item) => {
            if (item.id === 'rtttype') {
              rtttype = item.value;
            }
          });

          for (let index = 20; index <= 89; index++) {
            fleetOptions.push({ showName: index, value: index });
          }

          res.forEach((item) => {
            //区号设置
            if (item.name.indexOf('[zone]') > -1) {
              item.value = zoneOptions[0].value;
              item.options = zoneOptions;
            }
            //队号设置
            if (item.name.indexOf('[fleet]') > -1) {
              if (rtttype === 2 || rtttype === 8) {
                item.hidden = true;//打开页面默认终端类型为系统调度台，队号隐藏
                item.batch_hidden = true;
              } else {
                item.value = fleetOptions[0].value;
                item.options = fleetOptions;
              }
            }
            //个号设置
            if (item.name.indexOf('[number]') > -1 || item.name.indexOf('[startNo]') > -1 || item.name.indexOf('[endNo]') > -1) {
               if (item.validate) {
                if (rtttype === 2 || rtttype === 8) {
                  item.validate.range = [[100, 109], this.$t('SubscriberIms.numDialTip1')];//系统调度台及ULP队号范围
                  item.validate.rangeLength = [[3,3],this.$t('SubscriberIms.solid_3')]
                  item.placeholder = '100~109';
                } else {
                  item.validate.range = [[200,899], this.$t('SubscriberIms.numDialTip8')];
                  item.validate.rangeLength = [[3,3],this.$t('SubscriberIms.solid_3')]
                  item.placeholder = '200~899';
                }
              }
            }
          });

        }
        else if(_dialPlan === this.dialPlanList[0])//DMR
        {
          res.forEach((item) => {
            //区号设置
            if (item.name.indexOf('[zone]') > -1) {
              item.value = zoneOptions[0].value;
              item.options = zoneOptions;
            }
            //队号设置,DMR无队号
            if (item.name.indexOf('[fleet]') > -1) {
              item.hidden = true;
              item.batch_hidden = true;
            }
            //个号设置

            if (item.name.indexOf('[number]') > -1 || item.name.indexOf('[startNo]') > -1 || item.name.indexOf('[endNo]') > -1) {
              if(this.checkDmrZone(zoneOptions[0].value)){
                if (item.validate) {
                  item.validate.range = [[1, 99999], this.$t('SubscriberIms.numDialTip7')];
                  item.validate.rangeLength = [[5,5],this.$t('SubscriberIms.solid_5')]
                  item.placeholder = '00001~99999';
                }
              }
              else{
                if (item.validate) {
                  item.validate.range = [[0, 99999], this.$t('SubscriberIms.numDialTip2')];
                  item.validate.rangeLength = [[5,5],this.$t('SubscriberIms.solid_5')]
                  item.placeholder = '00000~99999';
                }
              }
            }
          });
        }
        else if(_dialPlan === this.dialPlanList[2])//ZJ
        {
          res.forEach((item) => {
            //区号设置
            if (item.name.indexOf('[zone]') > -1) {
              item.value = zoneOptions[0].value;
              item.options = zoneOptions;
            }
            //队号设置,ZJ无队号
            if (item.name.indexOf('[fleet]') > -1) {
              item.hidden = true;
              item.batch_hidden = true;
            }
            //个号设置，打开终端类型默认为系统调度台，各号范围为30000~30019
            if (item.name.indexOf('[number]') > -1 || item.name.indexOf('[startNo]') > -1 || item.name.indexOf('[endNo]') > -1) {
              if (item.validate) {
                item.validate.range = [[1, 32767], this.$t('SubscriberIms.numDialTip3')];
                item.validate.rangeLength = [[5,5],this.$t('SubscriberIms.solid_5')];
                item.placeholder = '00001~32767';
              }
            }
          });
        }
        res.forEach((item) => {
          if (item.name === 'vpnid') {
            item.value = propinfo.vpnname;
            this.info.vpnid = propinfo.vpnid;
            item.readonly = true;
          }
        })
        return resultMap;
      },
      /**
       * 组织架构列表查询
       * @param propinfo
       * @param res
       * @returns {*}
       */
      getVpnInfo(propinfo, $this) {
        if (this.opCode === 'batchMod' && !this.checkboxMap.vpnid) {
          return;
        }
        // 组织架构查询赋值
        this.$refs.qryVpnInfoPage.show();
        console.log('vpndata', this.vpndata);
        this.$refs.organizationalTreeInner.staDoFieldsList = this.vpndata;
        this.$refs.organizationalTreeInner.getOrganizationalTreeWithNeid();
        return;
        this.paramForInner.neId = this.neid;
        const param = {

        };
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
          if (response.status === 200) {
            this.$refs.qryVpnInfoPage.show();
          } else {
            EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.qryVpnFailTip')});
          }
        });
      },
      initTemplateInfo() {
        const  paramTemplate = {
          vo: {
            0: { page: '1', pageSize: 1000 },
            1: { neid: this.neid, tempname: '', temptype: 1 }
          },
          info: {
            msgid: '',
            neid: this.neid,
            operation: 'qryTemplate'
          },
          page: {
            pageNo: 1,
            pageSize: 1000
          }
        };
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramTemplate).then((response) => {
          if (response.status === 200 && response.data.errorCode === '0') {
            const template = new Map();
            const res = JSON.parse(response.data.resultVal);
            console.log(res);
            res.result.forEach((item) => {
              template.set(item.tempnum, item.context);
              this.templateInfo.push({ text: item.tempname, value: item.tempnum });
            });
            this.templateInfoMap = template;
          }
        });
      },
      templateChange(args) {
        console.log(this.templateInfoMap.get(args.itemData.value));
        const $this = this;
        $this.$refs.subInfo && $this.$refs.subInfo.$children[0].setDatas(JSON.parse(this.templateInfoMap.get(args.itemData.value)));
        $this.$refs.serviceProfileInfo.$children[0].setDatas(JSON.parse(this.templateInfoMap.get(args.itemData.value)));
        $this.$refs.supplementaryInfo.$children[0].setDatas(JSON.parse(this.templateInfoMap.get(args.itemData.value)));
      },
      getDatas() {
        const validateReturn = this.$refs.impuinfo.validateResult()
          && this.$refs.serviceProfileInfo.validateResult()
          && this.$refs.supplementaryInfo.validateResult()
          && (this.$refs.subInfo ? this.$refs.subInfo.validateResult() : true);

        if (!validateReturn) {
          console.log('表单验证不通过');
          return;
        }

        const returnObj          = {};
        const impuinfo           = this.$refs.impuinfo.getDatas();
        const serviceProfileInfo = this.$refs.serviceProfileInfo.getDatas();
        const supplementaryInfo  = this.$refs.supplementaryInfo.getDatas();

        Array.from(impuinfo).forEach(([key, value]) => {
          returnObj[key] = value;
        });

        if (this.$refs.subInfo) {
          const subInfo          = this.$refs.subInfo.getDatas();
          Array.from(subInfo).forEach(([key, value]) => {
            returnObj[key] = value;
          });
        }

        Array.from(serviceProfileInfo).forEach(([key, value]) => {
          returnObj[key] = value;
        });
        Array.from(supplementaryInfo).forEach(([key, value]) => {
          returnObj[key] = value;
        });

        if(!this.getImpuByDialplan(returnObj, this.opCode)) {
          return;
        }

        const formData = {
          returnObj: returnObj,
          vpnid: this.info.vpnid,
          username: this.username,
          opCode: this.opCode,
          passwordbefore: this.passwordbefore,
          realmbefore: this.realmbefore,
          lteimsibefore: this.lteimsibefore,
          checkboxMap: this.checkboxMap,
        }

        const { devAdapter } = this.$parent.$parent.$parent.$refs;
        const obj = devAdapter.getAddUserRecords(formData);

        if (obj && obj['password[confirm]'] != obj['password[origin]']) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.passwordEqual')});
          return null;
        }

        console.log('newRecord=',obj);
        return obj;
      },
      getGrpnumberBussiness(map) {
        // 号码拼写
        map.set('grpnum', map.get('userAlias'));
        return map;
      },
      initAnotherBussinessDatas(datas) {
        datas.confirmpassword = datas.password;
      },
      reMount() {
        this.$refs.impuinfo.reMount();
        this.$refs.serviceProfileInfo.reMount();
        this.$refs.supplementaryInfo.reMount();
      },
      getSelectList() {
        this.$refs.impuinfo.reMount();
        this.$refs.serviceProfileInfo.reMount();
        this.$refs.supplementaryInfo.reMount();
      },
      clearSelfPage() {
        this.hasReset = false;
        this.$nextTick(() => {
          this.hasReset = true;
        });
      },
      bindClickAfterPageCreated() {

        // 输入框点击事件----根据name名称找到组件
        const componentArray = this.$refs.impuinfo.$children[0].$children;
        componentArray.forEach(item => {
          if (this.opCode === 'batchMod' || this.opCode === 'mod'){
            if (item.$refs.vpnid) {
              // 输入框右侧增加"选择超链接"
              const input = document.createElement('A');
              input.onclick = this.getVpnInfo;
              input.className = 'h-subscriber-atag';
              const valueOfAtag = document.createTextNode(this.$t('SubscriberIms.selectVButton'));
              input.appendChild(valueOfAtag);
              item.$refs.vpnid.parentElement.className = 'h-subscriber-div-innerwitha_user';
              item.$refs.vpnid.parentElement.appendChild(input);
            }
          }
          if(this.opCode === 'add' || this.opCode === 'mod'){
            if (item.$refs.username) {
              // 输入框右侧增加"选择超链接"
              const input = document.createElement('A');
              input.onclick = this.openStaffInfo;
              input.className = 'h-subscriber-atag';
              const valueOfAtag = document.createTextNode(this.$t('SubscriberIms.selectVButton'));
              input.appendChild(valueOfAtag);
              item.$refs.username.parentElement.className = 'h-subscriber-div-innerwitha_user';
              item.$refs.username.parentElement.appendChild(input);
            }
          }
          return null;
        });
      },
      /**
       * 更新和关闭组织架构
       */
      setChooseVpnInfo(event) {
        if (event.keyCode === 13) {
          return;
        }
        const selectNode = this.$refs.organizationalTreeInner.getNode();
        if (!selectNode) {
          EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.chooseNodeTip')});
        } else {
          this.$refs.organizationalTreeInner.clear();
          this.$refs.qryVpnInfoPage.clear();
          this.$refs.qryVpnInfoPage.close();
          this.$refs.impuinfo.$refs.bus.getRefObj('vpnid').value=selectNode.text;
          this.$refs.impuinfo.$refs.bus.validateResult(['vpnid']);
          this.info.vpnid = selectNode.id.split('_')[2];
        }
      },
      closeQryVpnInfoPage() {
        this.$refs.organizationalTreeInner.clear();
        this.$refs.qryVpnInfoPage.clear();
        this.$refs.qryVpnInfoPage.close();
      },
      openStaffInfo() {
        this.$refs.StaffInfoPage.show();
        this.$refs.staff.getGridData(this.info.vpnid,this.vpnclass,this.neversion);
      },
      setStaffInfo(){
        const staffname = this.$refs.staff.getCheckedData();
        console.log("staffname:",staffname);
        this.$refs.StaffInfoPage.clear();
        this.$refs.StaffInfoPage.close();
        this.$refs.impuinfo.$refs.bus.getRefObj('username').value=staffname;
        this.$refs.impuinfo.$refs.bus.validateResult(['username']);
        if(staffname)
          this.username = staffname;
      },
      closeStaffInfo(){
        this.$refs.StaffInfoPage.clear();
        this.$refs.StaffInfoPage.close();
      },
      changeFun(args) {
        const arrDevice = JSON.parse(this.arrDeviceBak);
        if (args.checked) {
          this.setEnabled('serviceProfileInfo', arrDevice);
          this.checkboxMap.serviceProfileInfo = true;
        } else {
          this.setDisabled('serviceProfileInfo', arrDevice);
          this.checkboxMap.serviceProfileInfo = false;
        }
      },
      changeSupplementFun(args) {
        const arrServe = JSON.parse(this.arrServeBak);
        if (args.checked) {
          this.setEnabled('supplementaryInfo', arrServe);
          this.checkboxMap.supplementaryInfo = true;
        } else {
          this.setDisabled('supplementaryInfo', arrServe);
          this.checkboxMap.supplementaryInfo = false;
        }
      },
      changeBaseFun(args, dom) {
        const arrBaseInfo = JSON.parse(this.arrBaseBak);
        if (args === undefined) {
          return;
        }
        console.log(args, dom);
        const name = args.path[5].__vue__.data.name;
        const arrBase = arrBaseInfo.filter((item) => item.name === name);
        if (args.target.checked) {
          this.setEnabled('impuinfo', arrBase);
          this.checkboxMap[name] = true;
        } else {
          this.setDisabled('impuinfo', arrBase);
          this.checkboxMap[name] = false;
        }
      },

    },
    data() {
      return {
        funcMap:'',
        vpndata: [],
        disableNode:[],
        hasReset: true,
        showTemplate: true,
        showCheckbox: false,
        showSupplementaryInfo:true,
        arrBaseBak: undefined,
        arrDeviceBak: undefined,
        arrServeBak: undefined,
        checkboxMap: {
          serviceProfileInfo: false,
           supplementaryInfo: false
        },
        templateInfo: [], // 宽带模板列表
        templateInfoMap: {}, // 模板信息缓存
        dialPlan: '',
        dialPlanList: [4,5,6], // 网管只支持p3\dmr\浙江拨号方案
        neid:'',
        neversion: '',
        passwordbefore:'',
        realmbefore:'',
        lteimsibefore:'',
        rtttypeRef: undefined,
        passwordRegex: '(?!^(\\d+|[a-zA-Z]+|[!#\\$%&\\*\\+-/<=>\\?@\\[\\]\\^\\{_\\}~]+)$)^[\\w!#\\$%&\\*\\+-/<=>\\?@\\[\\]\\^\\{_\\}~]+$',
        info: {
          vpnid: '',
        },
        vpnclass:'',
        username:'',
        formParamsUserImpuInfo: {
          json: '',
          formId: `${this.opCode}impuinfoBussiness`,
          subObject: '',
          modelName: 'impuinfo',
        },
        formParamsSubImpuInfo: {
          json: '',
          formId: `${this.opCode}subinfoBussiness`,
          subObject: '',
          modelName: 'subinfo',
        },
        formParamsUserServiceProfileInfo: {
          json: '',
          formId: `${this.opCode}serviceProfileInfoBussiness`,
          subObject: '',
          modelName: 'serviceProfileInfo',
        },
        formParamsUserAdditionInfo: {
          json: '',
          formId: `${this.opCode}supplementaryInfoBussiness`,
          subObject: '',
          modelName: 'supplementaryInfo',
        },
        paramForGetJson: {
          msgid: this.msgid,
          neid: this.neid
        },
        paramForInner: {
          vo: {
            0: this.neid,
            1: 'TcfRegionNum',
            2: 'RegionNum'
          },
          info: {
            neId: this.neid,
            operation: 'getZone'
          }
        },
        operetion: {
          getZone: 'getZone'
        },
        dialog: {
          vpnstyles: {
            width: '20%',
            height: '38%',
            zIndex:1212,
            visible: false,
            model: true
          },
          staffstyles: {
            width: '75%',
            height: '60%',
            zIndex:1212,
            visible: false,
            model: true
          },
          element: {
            eleQryVpnInfo: {
              target: this.$refs.qryVpnInfoPage,
              refName: 'qryVpninfo',
              buttonGroup: [
                {
                  click: this.closeQryVpnInfoPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
                },
                {
                  click: this.setChooseVpnInfo, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
                }
              ],
              title: this.$t('SubscriberIms.organization'),
              isClose: true
            },
            eleStaffInfo: {
              target: this.$refs.StaffInfoPage,
              refName: 'StaffInfo',
              buttonGroup: [
                {
                  click: this.closeStaffInfo, buttonModel: { content: this.$t('SubscriberIms.cancel') }
                },
                {
                  click: this.setStaffInfo, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
                }
              ],
              title: this.$t('SubscriberIms.staffTitle'),
              isClose: true
            }
          },
        },
      };
    },
    computed: {
      bindOnChangeInterface() {
        this.funcMap = new Map();
        this.$bindRtttype('rtttype');
        this.$bindZone('impu[zone]');
        this.$bindFleet('impu[fleet]');
        this.$bindInvalidtime('invalidtime');
        return this.funcMap;
      },
      bindOnChangeSupplementaryInfo() {
        this.funcKeyUpMap = new Map();
        this.$bindPassword('password[origin]', 'password[confirm]');
        return this.funcKeyUpMap;
      },
      showSubInfo() {
        return this.neversion.indexOf("_V22") > 0 && (this.opCode == 'add' || this.opCode == 'mod');
      }
    },
  };
</script>

<style scoped>

</style>
